import { Row, Button } from "antd";
import { useEffect, useState } from "react";

const News = ({ title, image, description, slug, isMobile, lang}) => {  
	
	const [readMoreLink, setReadMoreLink] = useState('Leer más');
	useEffect(() => {
		if (lang === 'es') {
			setReadMoreLink('Leer más');
		} else if (lang === 'en') {
			setReadMoreLink('Read more');
		} else if (lang === 'pt') {
			setReadMoreLink('Leia mais');
		}
	}, [lang]);
	
	return (
		<>
			<Row style={{
				paddingLeft: '20px',
				paddingRight: '20px',
				// width: isMobile ? '305px' : '100%',
				width: isMobile ? '100%' : '100%',
				height: '100%',
				display: 'flex',
				'flexDirection': 'column',
			}}>
				<Row
					style={{
						// height: isMobile ? '392px' : '252px',
						width: '100%',
						// backgroundImage: `url(${image})`,
						// backgroundSize: 'cover',
						// backgroundPosition: 'center center',
						borderRadius: '24px',
						marginBottom: '32px'
					}}
				>
					<img
						loading="lazy"
						style={{
							width: '100%',
							height: '100%',
							minHeight: '230px',
							objectFit: 'cover',
							borderRadius: '24px',
						}}
						src={image}
					/>
				</Row>
				<Row>
					<span className='s3-subtitle-600'>{title}</span>
				</Row>
				<Row>
					<div 
					style={{
						marginTop: '-20px'
					}}
						className='b4-body-400'
						dangerouslySetInnerHTML={{ __html: description }}
					/>
				</Row>
				<Row>
					<Button 
						className="bt-medium-500" 
						style={{color: '#0027F9', paddingLeft: 0 }} 
						type="link" 
						href={slug} 
						variant="link">
							{readMoreLink}
					</Button>
				</Row>
			</Row>
		</>
	);
};

export default News;